import { LegalPage } from "./legal-page.tsx";

export function RefundPolicyPage() {
  return <LegalPage slug="refund-policy" />;
}
